
const SocialMediaIcons=()=>{

    return(
        <div className="flex justify-center md:justify-start my-10 gap-7 ">
         <a
         className="hover:opacity-50 transition duration-500 " 
         href="https://www.linkedin.com/in/muluneh-debebe-1404b728a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
         target="_blank"
         rel="noreferrer"

         >
            <img alt="linkedin-link" src="assets/linkedin.png"className="w-16 md:w-6" />

         </a>

         <a
         className="hover:opacity-50 transition duration-500" 
         href="https://t.me/MD4648"
         target="_blank"
         rel="noreferrer"
         >
            <img alt="linkedin-link" src="assets/telegram.png" className="w-16 md:w-6"/>

         </a>
       
         <a
         className="hover:opacity-50 transition duration-500" 
         href="https://instagram.com/md__4048?igshid=OGQ5ZDc2ODk2ZA=="
         target="_blank"
         rel="noreferrer"
         >
            <img alt="linkedin-link" src="assets/instagram.png" className="w-16 md:w-6"/>

         </a>

        </div>
    )


}

export default SocialMediaIcons 